/*
 * An Option's leading glyph. `Dropdowns.module.css` lays every row out on the list's shared
 * columns — `. check icon label end .` — and `MenuItem` keeps `check` for its checkbox or radio.
 * A listbox row has neither, so the icon spans both columns rather than sitting in `icon` with an
 * empty checkbox gutter in front of it.
 */
.icon {
  grid-area: check / check / icon / icon;
  color: var(--color__gray-500);
}

.svg {
  inline-size: 1rem;
  block-size: 1rem;
}

/*
 * The row's text. A `label` and a `description` handed in as two bare `Text`s stack as the two lines
 * of one item, `md` apart (`Text` trims its leading, so this is the visible gap), and a row with a
 * description takes `sm` of block padding either side so the space between rows is clearly larger
 * than the space within the pair. A caller that wraps its own layout in one child is untouched.
 */
.text {
  grid-area: label;
  display: grid;
  row-gap: var(--space__md);
  min-inline-size: 0;

  &:has(> [slot='description']) {
    padding-block: var(--space__sm);
  }
}
